<script>
import Layout from '@layouts/public.vue'
import { mapGetters, mapActions } from 'vuex'
import baseMixin from '@/mixins/baseMixin'
import { ErrorPageFactory } from '@/services/error/ErrorPageFactory'

export default {
  name: 'ErrorView',
  components: { Layout },
  mixins: [baseMixin],
  data() {
    return {
      factory: null,
      title: '',
      meta: '',
    }
  },
  computed: {
    ...mapGetters({
      isUserLoggedIn: 'auth/isUserLoggedIn',
      currentUser: 'auth/currentUser',
    }),
  },
  created() {
    this.factory = ErrorPageFactory(this.$route.meta.type)
    this.title = this.factory.errorText
    this.meta = this.factory.errorCode
  },

  methods: {
    ...mapActions({
      logout: 'auth/logOut',
    }),
    signOut() {
      this.logout({ redirect: true, nuke: true })
    },
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [{ name: 'description', content: this.meta }],
    }
  },
}
</script>

<template>
  <Layout class="slide-1">
    <div class="shapes-container">
      <div class="animation-shape shape-ring animation--rotating-diagonal">
        <div></div>
      </div>
      <div class="animation-shape shape-circle animation--clockwise">
        <div></div>
      </div>
      <div class="animation-shape shape-triangle animation--anti-clockwise">
        <div class="animation--rotating"></div>
      </div>
      <div class="animation-shape shape-diamond animation--anti-clockwise">
        <div class="animation--rotating"></div>
      </div>

      <div class="static-shape shape-ring-1"></div>
      <div class="static-shape shape-ring-2"></div>
      <div class="static-shape shape-circle-1"></div>

      <div class="static-shape pattern-dots-1"></div>
      <div class="static-shape pattern-dots-2"></div>
    </div>
    <div class="text-center  white--text">
      <div class="d-flex flex-column align-center">
        <h3
          class="error-title font-weight-black my-10  text-center"
          style="width: fit-content;"
        >
          <div class="errorHeader">
            <div class="bgHighlight pr-4"></div>
            <div class="text  display-4 z-index-1">
              {{ factory.title }}
            </div>
          </div>
        </h3>

        <p class="error-desc display-1 font-weight-bold mt-0 z-index-1">
          {{ factory.desc }}
        </p>
        <p
          class="error-sub-desc subtitle-1 font-weight-medium z-index-1 ws-pre"
        >
          {{
            `${factory.showErrorCode ? '(' + factory.errorCode + ') ' : ''} ${
              factory.subDesc
            }`
          }}
        </p>

        <div class="error-code" :data-error-code="factory.errorText"></div>

        <div
          :class="[
            'd-flex justify-center mt-10',
            $mq === 'sm' || $mq === 'xs' ? 'flex-column ' : '',
          ]"
        >
          <BaseButton
            v-show="isUserLoggedIn || currentUser"
            id="error-page-logout-btn"
            x-large
            text
            outlined
            color="white"
            :class="[
              'rounded-lg text-capitalize no-letter-spacing',
              isMobileViewPort ? 'mb-2' : 'mr-2',
            ]"
            @click="signOut"
          >
            <v-icon left class="white--text">mdi-arrow-left</v-icon>
            {{ $t('error.errorGenericLogOutButtonText') }}
          </BaseButton>
          <BaseButton
            id="error-page-go-home-btn"
            x-large
            light
            color="blue"
            :class="[
              'rounded-lg text-capitalize no-letter-spacing white--text',
              isMobileViewPort ? '' : 'ml-2',
            ]"
            :href="factory.goBackURL"
            v-text="factory.goBackText"
          >
          </BaseButton>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
.z-index-1 {
  z-index: 1;
}
.errorHeader {
  position: relative;
  text-align: center;

  .text {
    z-index: 1;
    position: relative;
    margin-left: 10px;
    margin-right: 10px;
    font-size: 4rem;
    padding: 20px 20px 8px 20px;
    font-weight: bolder;
  }
  .bgHighlight {
    z-index: 1;
    margin-bottom: -10px;
    position: absolute;
    top: 0em;
    bottom: 0.3em;
    width: 100%;
    height: 100%;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #f5b51a;
  }
}
@import '@/styles/_animations.scss';
@import '@/styles/login.scss';
</style>
